import React, { useEffect, useState } from "react";
import Headers from "../LandingPage/Components/Headers";
import Contact from "../LandingPage/Components/Contact";
import CoursesDetails from "./CourseDetailPage";

export default function Parent() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Production-safe auth check
    const token = localStorage.getItem("access_token");

    setIsLoggedIn(!!token);
    setLoading(false);
  }, []);

  // Prevent UI flicker
    if (loading) {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#4AACC5] mx-auto"></div>
      </div>
    </div>
  );
}

  return (
    <div className="flex flex-col min-h-screen bg-white">
      
      {/* Header - hide if logged in */}
      {!isLoggedIn && (
        <header className="w-full">
          <Headers />
        </header>
      )}

      {/* Courses Section */}
      <main className="flex-grow">
        <CoursesDetails />
      </main>

      {/* Footer - hide if logged in */}
      {!isLoggedIn && (
        <footer className="w-full bg-gray-100 border-t">
          <Contact />
        </footer>
      )}
    </div>
  );
}
